import { FormConfirm, StyledForm, LoadingSpinner, SpinnerContainer } from "./MarketoForm.styles.js"
import React, { useCallback, useContext, useEffect, useState } from 'react';

import { AnalyticsContext } from "../../../context"
import PropTypes from 'prop-types';
import { zip } from "lodash";

const MarketoForm = (props) => {
  const { handleTealiumEvent, pageHistory } = useContext(AnalyticsContext)
  const { onSubmit, confirmMessage, eventAction, eventCategory, labelBellow} = props

  let marketoScriptId = `mktoForms`;
  const [scriptIsLoaded, setScriptIsLoaded] = useState(false);
  const [formIsLoaded, setFormIsLoaded] = useState(false);

  const [loading, setLoading] = useState(true);

  let zipCodePromise = Promise.resolve(); // Initialized as a resolved promise

  const loadScript = useCallback(() => {
    var s = document.createElement('script');
    s.id = marketoScriptId;
    s.type = 'text/javascript';
    s.async = true;
    s.src = process.env.GATSBY_MARKETO_SOURCE;
    s.onreadystatechange = function() {
      if (this.readyState === 'complete' || this.readyState === 'loaded') {
        setScriptIsLoaded(true);
      }
    };
    s.onload = () => setScriptIsLoaded(true);
    document.getElementsByTagName('head')[0].appendChild(s);
  }, [marketoScriptId])

  useEffect(() => {
    //Check if form element exists and either load the form or set isLoaded to true
    if (!document.getElementById(marketoScriptId)) {
      loadScript();
    } else {
      setScriptIsLoaded(true);
    }
  }, [loadScript, marketoScriptId]);

  useEffect(() => {
    // If the form is not loaded yet, loadForm
    if(scriptIsLoaded & !formIsLoaded ){
      var config = {
        podId: process.env.GATSBY_MARKETO_POD_ID,
        munchkinId: process.env.GATSBY_MUNCHKIN_INIT_VALUE,
         formIds : [props.id]
      };
      
      /* ---- NO NEED TO TOUCH ANYTHING BELOW THIS LINE! ---- */
      
      // function mktoFormChain(config) {
      
        /* util */
        var arrayify = getSelection.call.bind([].slice);
      
        /* const */
        var MKTOFORM_ID_ATTRNAME = "data-formId";
        
        /* fix inter-form label bug! */
        window.MktoForms2?.whenRendered(function(form) {
          var formEl = form.getFormElem()[0],
            rando = "_" + new Date().getTime() + Math.random();
      
          arrayify(formEl.querySelectorAll("label[for]")).forEach(function(labelEl) {
            var forEl = formEl.querySelector('[id="' + labelEl.htmlFor + '"]');
            if (forEl) {
              labelEl.htmlFor = forEl.id = forEl.id + rando;
            }
          });
        });
      
        /* chain, ensuring only one #mktoForm_nnn exists at a time */
        arrayify(config.formIds).forEach(function(formId) {
          var loadForm = window.MktoForms2?.loadForm.bind(window.MktoForms2 ?? null,config.podId,config.munchkinId,formId),
            formEls = arrayify(document.querySelectorAll("[" + MKTOFORM_ID_ATTRNAME + '="' + formId + '"]'));
      
          (function loadFormCb(formEls) {
            var formEl = formEls.shift();
            formEl.id = "mktoForm_" + formId;
      
            if(loadForm)
            loadForm(function(form) {
              
              formEl.id = "";
              if (formEls.length) {
                loadFormCb(formEls);
              }
              form.addHiddenFields({
                referringPage: `${pageHistory[0]}`
              })
  
              // Add tracking to the form on validation
              form.onValidate(async(status) => {
                // Await the zipCodePromise only if it's defined
                if (zipCodePromise) {
                  await zipCodePromise;
                }
                // Adds tracking for each time the submit button is clicked
                handleTealiumEvent({
                  eventcategory: eventCategory,
                  eventaction: eventAction,
                })
        
                // If successful validation
                status && 
                handleTealiumEvent({
                  eventcategory: eventCategory,
                  eventaction: eventAction,
                  eventlabel: "success"
                })
        
                // If unsuccessful validation
                !status &&
                handleTealiumEvent({
                  eventcategory: eventCategory,
                  eventaction: eventAction,
                  eventlabel: "error"
                })
              });


              
              form.onSuccess(async () => {
                // Continue with the existing logic after awaiting
                form.getFormElem().hide();
              
                if(document.getElementById('payFooterThankYou')) {
                  document.getElementById('payFooterThankYou').style.display = 'block';
                }
              
                if(confirmMessage && !onSubmit) {
                  let thankYouMessage = document.getElementsByClassName('confirmform')
                  thankYouMessage.style.display = 'block';
                }
                else if(!confirmMessage && onSubmit) {
                  // Calls the function passed in from props to handle the submit
                  onSubmit();
                }
                return false;  // Prevent form submission to the follow-up URL
              });
            });
            
          })(formEls);
        });

        setFormIsLoaded(true);
      // }
      
      // remove all styles using custom function when loaded

      window.MktoForms2?.whenReady(function(form) {

        destyleMktoForm(form);

        let formDivs = document.getElementsByClassName("mktoFieldWrap");
        
        for (let i = 0; i < formDivs.length; i++) {
          if(labelBellow){
            if(formDivs[i].children.length > 3 && formDivs[i].children[0].tagName == 'LABEL' && formDivs[i].children[2].tagName == 'INPUT'){
              formDivs[i].insertBefore(formDivs[i].children[2], formDivs[i].children[0]); // insert input before label
            }
            let inputWithValue = formDivs[i].children[0];
            inputWithValue.addEventListener("keyup", function(event){
              if(event.target.value.trim()==""){
                (event.target).parentElement.classList.remove("valueInside");
              }else{
                (event.target).parentElement.classList.add("valueInside");
              }
            });
          }
        }

        if (document.getElementById('marketo-loading-spinner')) {
          document.getElementById('marketo-loading-spinner').remove();
        }

        // Add a hidden field for the sales region if this form has a zip code field
        try {
          addSalesRegionToForm(form, zipCodePromise);
        }
        catch (error) {
          console.log('Error adding sales region to form. Form may not have a zip code field or another error occurred.');
        }

      });
    }
    setLoading(false);
  }, [pageHistory, scriptIsLoaded, props.id, onSubmit, confirmMessage, labelBellow, eventCategory, eventAction, handleTealiumEvent, formIsLoaded]);

  return (
    <>
      {loading ? (
        <SpinnerContainer id="marketo-loading-spinner">
          <LoadingSpinner/>
        </SpinnerContainer>
      ) : (
      <>
        <StyledForm className="marketo-form" data-formId={`${props.id}`}>
          <SpinnerContainer id="marketo-loading-spinner">
            <LoadingSpinner/>
          </SpinnerContainer>
        </StyledForm>
        <FormConfirm className="confirmform" style={{ display: 'none' }}>
          <p>{props.confirmMessage}</p>
        </FormConfirm>
      </>
      )}
    </>
  );
}

export default MarketoForm;


MarketoForm.propTypes = {
  id: PropTypes.number.isRequired,
  labelBellow: PropTypes.bool,
  confirmMessage: PropTypes.string,
  eventCategory: PropTypes.string,
  eventAction: PropTypes.string,
};

MarketoForm.defaultProps = {
  id: null,
  labelBellow: false,
  confirmMessage: null,
  eventCategory: "marketo form interaction",
  eventAction: "submit_cta"
};

/*
 * @author Sanford Whiteman
 * @version v1.104
 * @license MIT License: This license must appear with all reproductions of this software.
 *
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
function destyleMktoForm(mktoForm, moreStyles){
  var formEl = mktoForm.getFormElem()[0],
    arrayify = getSelection.call.bind([].slice);

  // remove element styles from <form> and children
  var styledEls = arrayify(formEl.querySelectorAll("[style]")).concat(formEl);  
  styledEls.forEach(function(el) {
    el.removeAttribute("style");
  });

  // disable remote stylesheets and local <style>s
  var styleSheets = arrayify(document.styleSheets); 
  styleSheets.forEach(function(ss) {
    if ( ['mktoForms2BaseStyle', 'mktoForms2ThemeStyle'].indexOf(ss.ownerNode.id) !== -1 || formEl.contains(ss.ownerNode) ) {
      ss.disabled = true;
    }
  });
         
  if(!moreStyles) {
    formEl.setAttribute("data-styles-ready", "true");
  }
};


/**
 * Function to add a hidden field to a Marketo form with the sales region if the form has a zip code field
 * @param {object} form - The Marketo form object
 */
function addSalesRegionToForm(form, zipCodePromise) {
  if(!form || typeof form.getFormElem !== 'function') {
    return;
  }

  // Get the zip code field with name="PostalCode" or name="ZipCode" 
  let zipCodeField = form.getFormElem()[0].querySelector('[name="PostalCode"], [name="ZipCode"]');
  
  // Check if the form has a zip code field
  if(zipCodeField) {
    form.addHiddenFields({
      qualifiedSalesRegion: '' // by default, set the sales region to empty string; set later once zip code is entered
    });

    zipCodeField.addEventListener('input', () => {
      zipCodePromise = zipCodeFilledIn(zipCodeField, form);
    });
  } else {
    // Resolve the promise immediately if there's no zipCode field
    zipCodePromise = Promise.resolve();
  }
}



/**
 * Event listener for when the zip code field is changed and has a valid 5 digit zip code
 * @param {object} zipCodeField - The zip code input element
 * @param {object} form - The Marketo form object
 */
function zipCodeFilledIn(zipCodeField, form) {
  // Return the promise so we can wait for it elsewhere
  return new Promise((resolve, reject) => {
    if (!/^\d{5}$/.test(zipCodeField.value)) {
      console.error('Invalid zip code');
      // Resolve the promise immediately if the zip code is invalid
      resolve();
      // But, set the Marketo form as invalid
      form.showErrorMessage('Please enter a valid zip code.');
      form.submitable(false);
      return;
    } else {
      // Set the Marketo form as valid if the zip code is valid
      form.submitable(true);
    }
    try {
      fetch(process.env.GATSBY_QUALIFIED_SALES_TERRITORY_ZIP_CODE_MAPPING_URL, { headers: { 'Content-Type': 'text/csv' } })
        .then(response => response.text())
        .then(data => {
          let rows = data.split('\n');
          let result = binarySearchForZip(rows, zipCodeField.value);
          
          if (result !== -1) {
            form.vals({ qualifiedSalesRegion: result });
          }

          // If we got this far, also send the payload to Qualified
          sendPayloadToQualified(result);

          resolve();
        })
        .catch (error => {
          console.error('Error:', error);
          resolve(); // We resolve even on error to ensure the form can proceed.
        });
    } catch (error) {
      console.error('Error:', error);
      resolve(); // We resolve even on error to ensure the form can proceed.
    }
  });
}

/**
 * Binary search to find the zip code in the CSV rows
 * @param {Array<string>} rows - The CSV rows
 * @param {string} zip - The zip code to search for
 * @returns {string} The sales region corresponding to the zip code or -1 if not found
 */
function binarySearchForZip(rows, zip) {
  // Check arguments are valid
  if (!rows || !zip) {
    // Throw error
    throw new Error('Invalid arguments');
  }
  // Check if the rows argument is an array
  if (!Array.isArray(rows)) {
    // Throw error
    throw new Error('rows argument must be an array');
  }
  // Check if the zip argument is a 5 digit string
  if (!/^\d{5}$/.test(zip)) {
    // Throw error
    throw new Error('zip argument must be a 5 digit string');
  }
  let start = 0;
  let end = rows.length - 1;

  while (start <= end) {
    let middle = Math.floor((start + end) / 2);
    let row = rows[middle].split(',');

    if (row[1] === zip) {
      return row[0]; // sales region
    } else if (parseInt(row[1], 10) < parseInt(zip, 10)) {
      start = middle + 1;
    } else {
      end = middle - 1;
    }
  }

  return -1;
}


// Send hidden field qualifiedSalesRegion to Qualified via their JavaScript API
function sendPayloadToQualified(qualifiedSalesRegion){
  // Check if the Qualified object exists after window load
  let qualified = window.qualified;
  if (qualified) {
    let fieldValues = {
      // NOTE: The keys in the payload must match the field names in Qualified
      form_sales_region: qualifiedSalesRegion
    };
    qualified("identify", fieldValues);
  }
}